module.exports = __webpack_public_path__ + "img/Error.91300aed.png";